import styled from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  gap: 5px;
`;

export const OtpCodeInput = styled.input`
  width: 1.2em;
  height: 1.8em;
  text-align: center;
  font-size: ${({ theme }) => theme.typography.heading.variant.h6.size.lg};
  border: 1px solid ${({ theme }) => theme.colors.medium};
  padding: 1px;
  border-radius: 0px;
  color: ${({ theme }) => theme.typography.text.color.primary};
  font-family: ${({ theme }) => theme.typography.heading.variant.h6.font};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    outline: none !important;
    border-radius: 0px;
    padding: 0px;
    border: 2px solid ${({ theme }) => theme.colors.primary};
  }
`;
